<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">
          Histórico de Compras
          <button type="button"
            class="btn-icon"
            (click)="goBackPage()"
            aria-label="Voltar página">
            <i class="fa fa-arrow-left botao-setinha-voltar" aria-hidden="true"></i>
          </button>
        </h1>
        <p class="paragrafo mb-4">Relatório de compras realizadas</p>

        @if (historicoCompras) {
          <span class="label c-gray">DESCRIÇÃO DO PRODUTO NO ARQUIVO</span>
        }

        <div class="row">
          @if (historicoCompras) {
            <div class="col-6 col-md-3">
              <label class="label-menor" for="dataInicial">Data Inicial</label>
              <input class="form-control" [(ngModel)]="dataInicial" id="dataInicial"
                placeholder="dd/mm/aaaa" dateMask [matDatepicker]="picker">
                <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker-custom-float"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            }
            @if (historicoCompras) {
              <div class="col-6 col-md-3">
                <label class="label-menor" for="dataFinal">Data Final</label>
                <input class="form-control" [(ngModel)]="dataFinal" id="dataFinal"
                  placeholder="dd/mm/aaaa" dateMask [matDatepicker]="picker2">
                  <mat-datepicker-toggle matSuffix [for]="picker2" class="datepicker-custom-float"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                  @if (dataFinalMenor) {
                    <p class="legenda-erro mt-2">Data final menor que data Inicial</p>
                  }
                </div>
              }
              @if (historicoCompras) {
                <div class="col-12 col-md-6">
                  <div class="mt-2">
                    <br>
                      <button class="botao" [ngClass]="{'disabled': !dataInicial || !dataFinal}" [disabled]="!dataInicial || !dataFinal" (click)="filtrar()">FILTRAR</button>
                      @if (dataFiltrada) {
                        <button class="botao-outline ms-3" (click)="limparFiltro()">LIMPAR FILTRO</button>
                      }
                    </div>
                  </div>
                }

                <div class="col-12">
                  <!-- TABELA -->
                  @if (historicoCompras) {
                    <table class="table table-hover border-bottom mt-4 mb-0" aria-describedby="tabela que lista o historico de compras">
                      <thead>
                        <tr>
                          <th scope="col">PEDIDO</th>
                          <th scope="col">EMISSÃO</th>
                          <th scope="col">ENTREGA</th>
                          <th scope="col">CÓDIGO</th>
                          <th scope="col">BENEFÍCIO</th>
                          <th scope="col">QUANTIDADE UNITÁRIA</th>
                          <th scope="col">SUBTOTAL</th>
                          <th scope="col">Nº DO CARTÃO</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- LINHA 1 -->
                        @for (compra of historicoCompras.data; track compra) {
                          <tr>
                            <td>{{compra.idPedido}}</td>
                            <td>{{compra.dataEmissao | appDate: 'dd/MM/yyyy'}}</td>
                            <td>{{compra.dataEntrega | appDate: 'dd/MM/yyyy'}}</td>
                            <td>{{compra.codigoProduto}}</td>
                            <td>{{compra.descProduto}}</td>
                            <td>{{compra.qtdDias}}</td>
                            <td>{{compra.subTotal}}</td>
                            @if (compra.codigoSerialCartao) {
                              <td>{{compra.codigoSerialCartao}}</td>
                            }
                            @if (!compra.codigoSerialCartao) {
                              <td>Não consta</td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  }

                  @if (historicoCompras === null) {
                    <div>
                      <div class="text-center">
                        <output class="spinner-border c-primary">
                          <span class="visually-hidden">Consultando histórico de compras ...</span>
                        </output>
                      </div>
                      <p class="legenda-spinner">Consultando histórico de compras ...</p>
                    </div>
                  }

                  @if (historicoCompras === false) {
                    <div class="text-center">
                      <img src="/assets/img/erro.png" width="230px" alt="Erro">
                      <p class="legenda-erro">Ocorreu um erro na consulta do histórico de compras.</p>
                    </div>
                  }

                  @if (historicoCompras === undefined) {
                    <div class="text-center">
                      <img src="/assets/img/vazio.png" width="230px" alt="usuario nao possui historico de compras">
                      <p class="legenda-vazio">Esse usuário ainda não possui histórico de compras.</p>
                    </div>
                  }
                </div>

              </div>

              @if (historicoCompras) {
                <div class="w-100 py-4 text-center">
                  <button class="botaoLongo px-5" (click)="exportarRelatorio()">EXPORTAR RELATÓRIO</button>
                </div>
              }

              <!-- FOOTER-CARD - PAGINAÇÃO -->
              @if (historicoCompras) {
                <div class="footer-card">
                  <div class="container-select">
                    <app-select
                      (change)="alteraQuantidadePorPagina()"
                      [value]="tamanho"
                      (valueChanges)="tamanho = $event"
                      name="tamanhoName"
                  [options]="[
                  {name : 'Exibir 3 históricos' , value : '3'} ,
                  {name : 'Exibir 6 históricos' , value : '6'} ,
                  {name : 'Exibir 9 históricos' , value : '9'}

                  ]"
                      optionValue="value"
                      optionText="name">
                  </app-select>
                </div>
                <!-- Paginação CENTRAL -->
                <div class="py-0 px-3">
                  @for (item of itensPaginacao; track item) {
                    <button class="btn-icon itens-pagina"
                      [ngClass]="{ 'item-ativo': pagina == item.valor}"
                      (click)="alteraPagina(item.valor)"
                      (keydown)="alteraPagina(item.valor)"
                      [attr.aria-label]="'Página ' + item.pagina"
                      type="button">
                      {{item.pagina}}
                    </button>
                  }
                </div>
                <div class="container-registros">
                  @if (historicoCompras.pageRequest.total == 1) {
                    <p><span class="itens-pagina me-0">{{historicoCompras.pageRequest.total}}</span> Registro foi encontrado</p>
                  }
                  @if (historicoCompras.pageRequest.total != 1) {
                    <p><span class="itens-pagina me-0">{{historicoCompras.pageRequest.total}}</span> Registros foram encontrados</p>
                  }
                </div>
              </div>
            }

          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
